// Only shown for CDCs — DAs don't need a badge (they're the default)
export default function AppTypeBadge({ type }) {
  const isCDC = type === 'Complying Development' || type === 'Complying Development Cert';
  if (!isCDC) return null;
  return (
    <span style={{
      background: "#1e3a5f",
      color: "#76c9f1",
      fontSize: 10,
      fontWeight: 700,
      padding: "2px 6px",
      borderRadius: 3,
      letterSpacing: 0.5,
      textTransform: "uppercase",
      border: "1px solid rgba(118,201,241,0.2)",
      flexShrink: 0,
    }}>CDC</span>
  );
}
